import { createApiClient } from "../utils/api";

export const AuthService = {
  login: (payload: any) => createApiClient(false).post("/login", payload),
  changePassword: (payload: any) => createApiClient(false).post("/changepassword", payload),
  resetPassword: (payload: any) => createApiClient(false).post("/forgot/password", payload),
  confirmOtp: (payload: any) => createApiClient(false).post("/verify/otp", payload)
};
